module.exports = __webpack_public_path__ + "assets/2f9352e0a2f653a13f5e5c1650102f82.png";